module.exports = __webpack_public_path__ + "67a92edb2567c70065eba91c6374ab25.png";